import { Directive, Input, OnChanges, SimpleChanges } from "@angular/core";
import { Validator, AbstractControl, NG_VALIDATORS } from "@angular/forms";

@Directive({
  selector: "[afterDate]",
  providers: [
    { provide: NG_VALIDATORS, useExisting: AfterDateDirective, multi: true }
  ]
})
export class AfterDateDirective implements Validator, OnChanges {
  
  @Input()
  afterDate: Date | undefined;  
  
  validate(c: AbstractControl): { [key: string]: any } | null {
    if (c.value && this.afterDate && c.value < new Date(this.afterDate)) {
      return {
        afterDate: true
      };
    }
    return null;
  }  
  
  onChange: (() => void) | undefined;  
  
  registerOnValidatorChange(fn: () => void): void {
    this.onChange = fn;
  }  
  
  ngOnChanges(changes: SimpleChanges): void {
    if ('afterDate' in changes && this.onChange) {
      this.onChange();
    }
  }
}